import { render } from "./DeductionSchedule.vue?vue&type=template&id=7079154e&scoped=true"
import script from "./DeductionSchedule.vue?vue&type=script&lang=js"
export * from "./DeductionSchedule.vue?vue&type=script&lang=js"

import "./DeductionSchedule.vue?vue&type=style&index=0&id=7079154e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7079154e"]])

export default __exports__